import { defineModel, serializable } from '../model'

class Operation {
    /**
     * ...
     */
    @serializable()
    name: string

    @serializable()
    id: number

    @serializable()
    description: string

    @serializable()
    active: boolean
}

export default defineModel(Operation)
